import React from 'react';
import { DatePicker } from 'antd';
import { dateToString, stringToDate } from '../../utils/dateUtils';

function _DatePicker({ value, onChange, ...props }) {
  return (
    <DatePicker
      aria-label="Select date"
      format={[
        'MM/DD/YYYY',
        'MM-DD-YYYY',
        'MMDDYYYY',
        'MM/D/YYYY',
        'MM-D-YYYY',
        'M/DD/YYYY',
        'M-DD-YYYY',
        'M/D/YYYY',
        'M-D-YYYY'
      ]}
      value={value ? stringToDate(value) : null}
      onChange={v => onChange(v ? dateToString(v) : undefined)}
    />
  );
}

export { _DatePicker as DatePicker };
